import { LegalLayout } from "@/components/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="February 2026" testId="privacy-page">
      <p>
        This Privacy Policy describes how <strong>Brimi AI</strong> ("we", "us", "our"),
        operated by <strong>Brajesh Chaudhary</strong>, a sole proprietorship at
        1 MP Road, Tundla, District Firozabad, Uttar Pradesh — 283204, collects,
        uses and protects information you share when you use{" "}
        <strong>brimi.in</strong> and its services
        (collectively, the "Service").
      </p>

      <h2>1. Information we collect</h2>
      <h3>a. Information you provide</h3>
      <ul>
        <li><strong>Account data:</strong> name, email address and password (stored as a one-way hash).</li>
        <li><strong>Profile data:</strong> selected class (IX–XII) and subjects.</li>
        <li><strong>Learning data:</strong> chat messages with the AI tutor, quiz attempts, and chapter progress.</li>
        <li><strong>Payment data:</strong> billing email and payment metadata (we never store card or UPI credentials — these are handled directly by Razorpay).</li>
      </ul>
      <h3>b. Information collected automatically</h3>
      <ul>
        <li>Standard log data such as IP address, device type, browser, and pages visited.</li>
        <li>Authentication tokens stored in your browser's local storage to keep you signed in.</li>
      </ul>

      <h2>2. How we use your information</h2>
      <ul>
        <li>To provide and personalise the tutoring experience.</li>
        <li>To process subscription payments through Razorpay.</li>
        <li>To send transactional emails (account verification, receipts, support replies).</li>
        <li>To improve our AI prompts, quiz quality, and curriculum coverage.</li>
        <li>To detect fraud, abuse, and ensure platform security.</li>
      </ul>

      <h2>3. Third-party services</h2>
      <p>To deliver our Service we rely on the following processors:</p>
      <ul>
        <li><strong>Razorpay</strong> — payment processing (subject to Razorpay's own privacy policy).</li>
        <li><strong>Anthropic Claude</strong> — AI chat responses. Chat messages are sent to Anthropic to generate replies.</li>
        <li><strong>OpenAI</strong> — text-to-speech narration for chapter notes.</li>
        <li><strong>MongoDB Atlas</strong> — database hosting.</li>
        <li><strong>Emergent (emergent.host)</strong> — application hosting and content delivery.</li>
      </ul>

      <h2>4. Data retention</h2>
      <p>
        We retain your account and learning data for as long as your account is active.
        You may request account deletion at any time by writing to{" "}
        <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a>; we will
        permanently delete your personal data within 30 days, except where retention
        is required by law (e.g. tax invoices).
      </p>

      <h2>5. Children's data</h2>
      <p>
        Brimi AI is designed for school students (typically aged 13–18). Users under
        18 should use Brimi AI under the supervision of a parent or legal guardian.
        We do not knowingly collect data from children under 13. If you believe
        a child under 13 has provided us data, please contact us and we will delete it.
      </p>

      <h2>6. Security</h2>
      <p>
        We use industry-standard safeguards: encrypted HTTPS, bcrypt password hashing,
        signed JWT sessions, and TLS-encrypted database connections. No method of
        transmission over the Internet is 100% secure, but we work hard to protect
        your information.
      </p>

      <h2>7. Your rights</h2>
      <p>You can, at any time:</p>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Request correction or deletion of your data.</li>
        <li>Withdraw consent for non-essential processing.</li>
        <li>Export your chat history and quiz attempts.</li>
      </ul>
      <p>
        Send any such request to{" "}
        <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a>.
      </p>

      <h2>8. Cookies</h2>
      <p>
        We use only essential cookies / local-storage for authentication and session
        management. We do not use advertising or third-party tracking cookies.
      </p>

      <h2>9. Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Material changes will
        be notified by email or a notice on the Service at least 7 days before they
        take effect.
      </p>

      <h2>10. Contact</h2>
      <p>
        Grievance Officer: <strong>Brajesh Chaudhary</strong><br />
        Email: <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a><br />
        Phone: +91 79836 33563<br />
        Address: 1 MP Road, Tundla, Dist. Firozabad, UP — 283204, India
      </p>
    </LegalLayout>
  );
}
